import moment from 'moment';

export default (state: any, action: any) => {
  switch (action.type) {
    case "SET_CHARTS_FILTER":
      return {
        ...state,
        activeFilter: action.payload.activeFilter,
        activeRange: getFilterRange(state, action)
      }
    case "SET_CHARTS_LABELS":
      return {
        ...state,
        chartLabels: action.payload.labels,
      }
    case "SET_WORKING_HOURS":
      return {
        ...state,
        workingHours: action.payload.workingHours,
      }
    case "SET_TASKS":
      return {
        ...state,
        tasks: action.payload.tasks,
      }
    case "SET_ACTIVITIES":
      return {
        ...state,
        activities: action.payload.activities,
      }
    case "SET_EMPLOYEES":
      return {
        ...state,
        employees: action.payload.employees,
      }
    default:
      return state;
  }
};

const getFilterRange = (state: any, action: any) => {
  let from;
  let to;
  switch (action.payload.activeFilter) {
    case "currentWeek":
      from = moment().startOf('isoWeek').format('YYYY-MM-DD');
      to = moment().endOf('isoWeek').format('YYYY-MM-DD');
      break;
    case "lastWeek":
      from = moment().subtract(1, 'weeks').startOf('isoWeek').format('YYYY-MM-DD');
      to = moment().subtract(1, 'weeks').endOf('isoWeek').format('YYYY-MM-DD');
      break;
    case "currentMonth":
      from = moment().startOf('month').format('YYYY-MM-DD');
      to = moment().endOf('month').format('YYYY-MM-DD');
      break;
    case "lastMonth":
      from = moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
      to = moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD');
      break;
    default:
      break;
  }
  return { from, to }
}